import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'
import { useNavigate } from 'react-router-dom'
import Lib from 'library'

const DataIntro = () => {

	const App = useApp()
	const navigate = useNavigate()
	const [checkCrdt, setCheckCrdt] = useState(); // 신용 활성화 여부
	const [checkMdata, setCheckMdata] = useState(); // 마이데이터 활성화 여부

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")

		Lib.post(`/api/data/crtf/dataupddt`, (data) => {
			setCheckCrdt(data?.crdt ? true : false);
			setCheckMdata(data?.mdata ? true : false);
		});
	}, [])

	const onDataList = ()=> {
		navigate("/home/dataSelect")
	}

	const onNoneData = () => {
		navigate("/home/dataNoneIntro");
	}

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_certificate_intro" />
				<h3 className="intro-tit mt_20">내가 공유하고 싶은 데이터를<br />쏙쏙! 골라서 링크 한줄에 전송!</h3>
				<ul className={styles["data-intro-list"]}>
					<li>나 이렇게 부자야!<br />주변 지인에게 보내면서 자랑은 덤덤!</li>
					<li className="mt_20">내 데이터는 항상 열려있지 않아요!<br />공유자 마음대로 오픈 시간 설정!</li>
				</ul>
			</div>
			<div className="padding flex-shrink_0" onClick={()=> (checkCrdt || checkMdata) ? onDataList() : onNoneData()}>
				<Button className="btn btn--big">증명서 공유하기</Button>
			</div>
		</div>
	)
}

export default DataIntro
